import {
  TableSettings,
  TableSettingsServiceClient,
  TableColumns,
  RoleTableSettings,
} from '../proto/admpb/tablesettings_grpc_web_pb';
import { auth } from '../lib/auth/Auth';
import { notifySuccess, notifyError } from '../components/Messages/Notification';

const service = new TableSettingsServiceClient(window.env.GRPC_ENDPOINT, {}, { ...auth });

const requestParameter = (param) => {
  let req = new TableSettings();
  req.setUsrId(param.userId);
  req.setGridName('ClientSite ' + param.title);
  req.setVisibleColumns(param.visibleColumns.join(','));
  req.setColumnOrder(param.columnOrder.join(','));

  return req;
};

export async function createTableSettings(param) {
  return new Promise((resolve, reject) => {
    const req = requestParameter(param);

    service.createTableSettings(req, {}, (error, response) => {
      if (error) {
        console.log(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function updateTableSettings(param) {
  return new Promise((resolve, reject) => {
    const req = requestParameter(param);

    service.updateTableSettings(req, {}, (error, response) => {
      if (error) {
        createTableSettings(param);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function readTableSettings(param) {
  return new Promise((resolve, reject) => {
    let req = new TableSettings();
    req.setUsrId(param.userId);
    req.setGridName('ClientSite ' + param.title);

    service.readTableSettings(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject().tableSetting);
      }
    });
  });
}

export async function deleteTableSettings(param) {
  return new Promise((resolve, reject) => {
    let req = new TableSettings();
    req.setUsrId(param.userId);
    req.setGridName('ClientSite ' + param.title);
    req.setComponent(param.componentName);

    service.deleteTableSettings(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject().tableSetting);
      }
    });
  });
}

export async function createTableColumns(param) {
  return new Promise((resolve, reject) => {
    let req = new TableColumns();
    req.setComponent(param.componentName);
    req.setColumns(param.columns);
    req.setTableType(param.tableType);

    service.createTableColumns(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject().tableColumn);
      }
    });
  });
}

export async function readRoleTableSettings(param) {
  return new Promise((resolve, reject) => {
    let req = new RoleTableSettings();
    req.setComponent(param.componentName);
    req.setRoleId(param.roleId);

    service.readRoleTableSettings(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject().roleTableSetting);
      }
    });
  });
}

export async function readTableColumns(param) {
  return new Promise((resolve, reject) => {
    let req = new TableColumns();
    req.setComponent(param.componentName);
    req.setTableType(param.tableType);

    service.readTableColumns(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject().tableColumn);
      }
    });
  });
}

export async function updateTableColumns(param) {
  return new Promise((resolve, reject) => {
    let req = new TableColumns();
    req.setComponent(param.componentName);
    req.setColumns(param.columns);
    req.setTableType(param.tableType);

    service.updateTableColumns(req, {}, (error, response) => {
      if (error) {
        // Create new table settings record as it is not found
        createRoleTableSettings(param);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function updateRoleTableSettings(param) {
  return new Promise((resolve, reject) => {
    let req = new RoleTableSettings();
    req.setRoleId(param.roleId);
    req.setComponent(param.componentName);
    req.setVisibleColumns(param.visibleColumns.join(','));
    req.setColumnOrder(param.columnOrder.join(','));

    service.updateRoleTableSettings(req, {}, (error, response) => {
      if (error) {
        // Create new table settings record as it is not found
        createRoleTableSettings(param);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function createRoleTableSettings(param) {
  return new Promise((resolve, reject) => {
    let req = new RoleTableSettings();
    req.setRoleId(param.roleId);
    req.setComponent(param.componentName);
    req.setVisibleColumns(param.visibleColumns.join(','));
    req.setColumnOrder(param.columnOrder.join(','));

    service.createRoleTableSettings(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject().roleTableSetting);
      }
    });
  });
}